import { CircularProgress, PaperProps, Typography } from '@mui/material';
import { ReactNode } from 'react';

import { Root } from './CircularProgressPaper.styled';

export interface CircularProgressPaperProps extends PaperProps {
  label?: ReactNode;
}

export const CircularProgressPaper = ({ label, children, ...otherProps }: CircularProgressPaperProps) => {
  return (
    <Root {...otherProps}>
      <CircularProgress color="inherit" thickness={4} size={20} />
      {label && (
        <Typography
          variant="button"
          sx={{
            marginLeft: 2,
          }}
        >
          {label}
        </Typography>
      )}
      {children}
    </Root>
  );
};
